export class ImageUpload {
    fileName: string;
    base64: string;
    savedFileName: string;

    constructor(fileName: string, base64: string) {
        this.fileName = fileName;
        this.base64 = base64;
    }
}
